module.exports = __webpack_public_path__ + "00_mole.3c7dfb32.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/kanai/male/layer2/00_mole.png
// module id = 61+A
// module chunks = 0